"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoUrlType = void 0;
var VideoUrlType;
(function (VideoUrlType) {
    VideoUrlType["TRAILER"] = "TRAILER";
    VideoUrlType["CLIP"] = "CLIP";
    VideoUrlType["CONTENT"] = "CONTENT";
    VideoUrlType["AUTOGENERATED_TRAILER"] = "AUTOGENERATED_TRAILER";
})(VideoUrlType = exports.VideoUrlType || (exports.VideoUrlType = {}));
//# sourceMappingURL=video-url-type.js.map